// tslint:disable:max-line-length
// tslint:disable:no-unused-expression

import { Directive, EventEmitter, ElementRef, Renderer, HostListener, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { FileManager } from '../source/fileManager.core';
import { Transfer } from '../source/transfer.core';
import { FileManagerOptions } from '../interface/fileManagerOptions.interface';
export class FileDropDirective implements OnInit, OnDestroy {
public fileHoverStart: EventEmitter<any> = new EventEmitter<any>();
public fileHoverEnd: EventEmitter<any> = new EventEmitter<any>();
public fileAccepted: EventEmitter<FileManager[]> = new EventEmitter<FileManager[]>();
public fileRejected: EventEmitter<Error> = new EventEmitter<Error>();
public fileOptions: FileManagerOptions;
public uploader: Transfer;
private _InputFile: any = null;
private _files: FileManager[];
/**
 * @param {?} element
 * @param {?} renderer
 */
public constructor(private element: ElementRef,
private renderer: Renderer) { }
/**
 * @return {?}
 */
public ngOnInit() {
        this._files = [];
        this.renderer.setElementClass(this.element.nativeElement, 'drop-area', true);
    }
/**
 * @return {?}
 */
public ngOnDestroy() {
        if (this._files.length > 0) {
            for (let /** @type {?} */ _file of this._files) {
                if (_file instanceof FileManager) {
                    if (!_file.isUploaded()) {
                        _file.cancel();
                        this.uploader.removeFile(_file);
                    }
                }
            }
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
public onDragOver(event: Event): void {

        // If we're already in the on-drag, don't bother with this
        if (this._InputFile === null) {
            // Get the object being dragged and reference it as a copy action
            this._InputFile = this.getDataTransferObject(event);
            if (this._InputFile === null) {
                return;
            }
            this.renderer.setElementClass(this.element.nativeElement, 'drop-enter', true);
            let /** @type {?} */ _dropValueText = 'Drop now';
            this.renderer.setElementAttribute(this.element.nativeElement, 'dropValueText', _dropValueText);

            // Let the client know
            this.fileHoverStart.emit();
        }

        // Don't propagate
        this.preventAndStopEventPropagation(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onDragLeave(event: Event): void {

        // Only bother if we have a file
        if (this._InputFile !== null) {
            this.renderer.setElementClass(this.element.nativeElement, 'drop-enter', false);
            this.renderer.setElementAttribute(this.element.nativeElement, 'dropValueText', '');

            // Finished with the file
            this._InputFile = null;
            if (event.currentTarget === ( /** @type {?} */((this as any))).element[0]) {
                return;
            }

            // Let the client know
            this.fileHoverEnd.emit();
        }

        // Don't let it continue
        this.preventAndStopEventPropagation(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onDrop(event: Event): void {

        // Only bother if we have a file
        if (this._InputFile !== null) {
            this.renderer.setElementClass(this.element.nativeElement, 'drop-enter', false);
            this.renderer.setElementAttribute(this.element.nativeElement, 'dropValueText', '');

            // Let the client know
            this.fileHoverEnd.emit();

            // Update our data
            this._InputFile = this.getDataTransferObject(event);

            if (this._InputFile.files.length === 0) {
                this._InputFile  = null;
                return;
            }

            let /** @type {?} */ filesData: FileList = this._InputFile.files;

            if (!this.hasFiles(this._InputFile.types)) {
                return;
            }

            this.readFile(filesData);

            this.fileAccepted.emit(this._files);

            // Finished with the file
            this._InputFile  = null;
        }

        // Don't let it continue
        this.preventAndStopEventPropagation(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
private preventAndStopEventPropagation(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }
/**
 * @param {?} _files
 * @return {?}
 */
private readFile(_files: FileList): void {
        let /** @type {?} */ fmObject: FileManager;
        for (let /** @type {?} */ i = 0; i < _files.length; i++) {
            let /** @type {?} */ file = _files[i];
            try {
                fmObject = new FileManager(file, this.fileOptions, this.uploader);
            } catch ( /** @type {?} */e) {
                if (e.status === 100) {
                    this.fileRejected.emit(e);
                } else {
                    this.fileRejected.emit(e);
                }
                throw new Error('Something goes wrong e: ' + e.message);
            }

            (fmObject.inQueue) && this._files.push(fmObject);
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
private getDataTransferObject(event: Event | any): DataTransfer {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;
    }
/**
 * @param {?} types
 * @return {?}
 */
private hasFiles(types: any): boolean {
        if (!types) {
            return false;
        }

        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }

        if (types.contains) {
            return types.contains('Files');
        }

        return false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    // Selector required in component HTML
    // tslint:disable-next-line:directive-selector
    selector: '[ng2File2Drop]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fileHoverStart': [{ type: Output },],
'fileHoverEnd': [{ type: Output },],
'fileAccepted': [{ type: Output },],
'fileRejected': [{ type: Output },],
'fileOptions': [{ type: Input },],
'uploader': [{ type: Input },],
'onDragOver': [{ type: HostListener, args: ['dragover', ['$event'], ] },],
'onDragLeave': [{ type: HostListener, args: ['dragleave', ['$event'], ] },],
'onDrop': [{ type: HostListener, args: ['drop', ['$event'], ] },],
};
}

function FileDropDirective_tsickle_Closure_declarations() {
/** @type {?} */
FileDropDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FileDropDirective.ctorParameters;
/** @type {?} */
FileDropDirective.propDecorators;
/** @type {?} */
FileDropDirective.prototype.fileHoverStart;
/** @type {?} */
FileDropDirective.prototype.fileHoverEnd;
/** @type {?} */
FileDropDirective.prototype.fileAccepted;
/** @type {?} */
FileDropDirective.prototype.fileRejected;
/** @type {?} */
FileDropDirective.prototype.fileOptions;
/** @type {?} */
FileDropDirective.prototype.uploader;
/** @type {?} */
FileDropDirective.prototype._InputFile;
/** @type {?} */
FileDropDirective.prototype._files;
/** @type {?} */
FileDropDirective.prototype.element;
/** @type {?} */
FileDropDirective.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
